import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function RegulatoryTrainingPrograms() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Trainings', 'Regulatory Training Programs']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Trainings
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Regulatory Training Programs
          </h3>
        </div>

        <p className="mb-4 text-[#05326D] font-bold">Empowering Regulatory Teams with Practical Knowledge & Global Compliance Expertise</p>

        <p className="mb-6 text-[#05326D]">
          At FDAC Consultancy, we believe that building a high-performing regulatory team begins with comprehensive, up-to-date training. In today’s
          dynamic regulatory landscape, it’s essential not only to understand current global guidelines but also to interpret and apply them
          effectively—especially when compiling submissions and responding to agency queries or deficiencies.
        </p>

        <p className="mb-8 text-[#05326D]">
          Our training programs are designed to equip professionals with the skills and insights needed to manage regulatory submissions across
          regulated and emerging markets, including the US, EU, and RoW.
        </p>

        <hr className="border-t border-gray-300 mb-8" />


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Objectives
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Deepen understanding of current regulatory frameworks and guidance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Strengthen submission planning and compilation skills</p>
        <p className="ml-2 mt-2 text-[#05326D]">Improve response strategies for regulatory deficiencies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Foster cross-functional regulatory competence</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Objectives
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Corporate Training Sessions: On-site or virtual workshops focused on regulatory filings for US FDA, EMA, and global markets</p>
        <p className="ml-2 mt-2 text-[#05326D]">Case Study-Based Learning: Sharing real-world experiences and practical insights to enhance decision-making and problem-solving</p>
        <p className="ml-2 mt-2 text-[#05326D]">Individual Training Modules: Personalized sessions for professionals seeking focused development in specific regulatory areas</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Who Should Attend?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Affairs Professionals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Quality Assurance Teams</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical & Pharmacovigilance Specialists</p>
        <p className="ml-2 mt-2 text-[#05326D]">Project Managers & Submission Coordinators</p>
        <p className="ml-2 mt-2 text-[#05326D]">New Entrants to Regulatory Roles</p>


        <p className="text-[#05326D] mt-4">
          FDAC’s training programs are led by seasoned experts with hands-on experience in global submissions, deficiency management, and regulatory
          strategy. Whether you’re building a new team or upskilling existing staff, our sessions deliver actionable knowledge that drives compliance and
          confidence.
        </p>
      </div>
    </div>
  );
}

export default RegulatoryTrainingPrograms;
